import axiosInstanceForTemplate from './axiosInstanceForTemplate';

export const getMerchandiseById = async (id) => {
	try {
		const res = await axiosInstanceForTemplate.get(`/merchandise/${id}`, {
			data: null
		});

		return res;
	} catch (error) {
		return error;
	}
};

export default { getMerchandiseById };
